<template>


       
       
    <MailjetNewsLetter/>

  
</template>

<script >
import axios from 'axios'
import MailjetNewsLetter from '../components/MailjetNewsLetter'

export default {
    name: 'contactUs',
    data(){
      return {
        email: null,
        phone:null,
        name:null,
        content:null,
        result:null,
        hasError:false
      }
    },
    components:{
        MailjetNewsLetter
    },
    methods: {
  
      sendSlack(){
        if (!this.email || !this.phone || !this.name || !this.content) {
            this.hasError = true
            this.result = 'Merci de renseigner tous les champs demandés pour envoyer votre demande'
        } else {
            axios.post('https://discord.com/api/webhooks/1122785755010433055/si9x3PtsXp0MndS8sqYSEQQbk6Z9WPyEVfmXUpAfg_coLbC1YZ_S9b74pacb_1anEIga', {content: "Nouvelle demande de contact de "+this.name+" (" + this.email + " - " + this.phone +") : " + this.content})
            this.hasError = false
            this.result = 'Votre demande de contact a bien été enregistrée'
        }

      }
    }
    
}
</script>

<style lang="scss" scoped>


.formLabel{
    font-size: 20px;
    font-weight: 600;
}
.contactForm{
    max-width: 500px;
}
.imgContact{
    background-image: url('../assets/img/contactezNous.png');
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
    height: 100%;
}
.terms{
    font-size: 12px;
    color: grey;
    margin: 80px 0px;
    text-align: justify;
}
.result {
    font-weight: 600;
    margin-top: 10px;
    color: var(--mainGreen);
}

</style>